import { RESPONSE_TYPE } from "../../const/vote";
import { IQuestionState } from "../../domain/ballot-state";
import { ApiIQuestion } from "../../domain/election";
import { QuestionValidationResult } from "../types";

export interface BasicTextInputValue {
    text_input: string;
}

export class BASIC_TEXT {
    static TYPE = RESPONSE_TYPE.BASIC_TEXT;
    static VERSION = "1.0.0";
    static INITIAL_VALUE: BasicTextInputValue = {
        text_input: ""
    }

    static normalize = (questionState?: IQuestionState): BasicTextInputValue => {
        if (!questionState) {
            return BASIC_TEXT.INITIAL_VALUE;
        }
        const { response_type, data_version, value } = questionState;

        if (response_type !== RESPONSE_TYPE.BASIC_TEXT) {
            return BASIC_TEXT.INITIAL_VALUE
        }
        if (data_version !== BASIC_TEXT.VERSION) {
            return BASIC_TEXT.INITIAL_VALUE;
        }
        if (!value || !value.text_input) {
            return BASIC_TEXT.INITIAL_VALUE
        }
        return value;
    };

    validate = (ballot: ApiIQuestion, vote: BasicTextInputValue | undefined): QuestionValidationResult => {
        if (!vote || !vote.text_input || vote.text_input.length === 0) {
            return {
                valid: false,
                empty: true,
                reasons: [{ reason: 'Text input required' }]
            };
        }
        return {
            valid: true,
            empty: false
        };
    };
}
